export function calcFilteredAttributes({facets, attributes}){
	const entries = Object.entries(attributes).flatMap(([k, v]) => {
		const f = facets[k];

		if (!f) return [];

		const newV = v.filter(x => f.some(({name}) => name === x));

		if (newV.length === 0) return [];

		return [[k, newV]];
	});
	return Object.fromEntries(entries);
}